/**
 * IIIF Paging properties
 *
 * - getFirst
 * - getLast
 * - getTotal
 * - getNext
 * - getPrevious
 * - getStartIndex
 */

// Linking
var getFirst = function getFirst(resource) {
  return resource.first ? resource.first[0] || null : null;
};

var getLast = function getLast(resource) {
  return resource.last ? resource.last[0] || null : null;
};

var getNext = function getNext(resource) {
  return resource.next ? resource.next[0] || null : null;
};

var getPrevious = function getPrevious(resource) {
  return resource.prev ? resource.prev[0] || null : null;
};

// Numbers
var getTotal = function getTotal(resource) {
  return resource.total ? parseInt(resource.total, 10) : null;
};

var getStartIndex = function getStartIndex(resource) {
  return resource.startIndex ? parseInt(resource.startIndex, 10) : 0;
};

export { getFirst, getLast, getNext, getPrevious, getStartIndex, getTotal };